import { useCivicFacilities } from '@services/common'
import { useTranslation } from 'react-i18next'

import { Label } from '@/components/ui/label'
import { MultiCombobox } from '@/components/ui/multi-combobox'

interface Props {
  value?: string[]
  onChange: (value: string[]) => void
  disabled?: boolean
}

export function CivicFacilitySelect({ value = [], onChange, disabled }: Props) {
  const { t } = useTranslation('application')
  const { data, isLoading } = useCivicFacilities({ search: '' })

  const options = (data ?? [])
    .filter((c) => c.id)
    .map((c) => ({ value: c.id!, label: c.name ?? '' }))

  return (
    <div>
      <Label className="mb-1.5 block">{t('civicFacilities.label')}</Label>
      <MultiCombobox
        value={value}
        onChange={onChange}
        options={options}
        loading={isLoading}
        disabled={disabled}
        placeholder={t('civicFacilities.placeholder')}
      />
    </div>
  )
}
